/**
 * FRONT-2891: an approval card's "Change it" opens Policy on the very row that
 * made it ask. The card knows the row by its (domain, action) pair — the same
 * pair the server's gate looked up — so the link carries the pair, and the
 * Policy page finds the row by it, scrolls to it and highlights it.
 */
import { systemSettingsPath } from '~/lib/system-settings-sections';

export const POLICY_RULE_PARAM = 'rule';

/** Policy, opened on one row. */
export function policyRuleHref(domain: string, action: string): string {
  const base = systemSettingsPath('policy');
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}${POLICY_RULE_PARAM}=${encodeURIComponent(`${domain}/${action}`)}`;
}

/** The row a link asked for, or null when the parameter is missing or malformed. */
export function parsePolicyRuleParam(value: string | null | undefined): { domain: string; action: string } | null {
  if (!value) return null;
  const slash = value.indexOf('/');
  if (slash <= 0 || slash === value.length - 1) return null;
  return { domain: value.slice(0, slash), action: value.slice(slash + 1) };
}

/** The id of the listed row that matches the pair; null when none does (the page then opens as usual). */
export function focusRuleId(
  rules: ReadonlyArray<{ id: string; domain?: string; action?: string }>,
  wanted: { domain: string; action: string } | null,
): string | null {
  if (!wanted) return null;
  return rules.find((r) => r.domain === wanted.domain && r.action === wanted.action)?.id ?? null;
}
